import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import About from "./components/about";
import Amount from "./components/amount";
import ThankYou from "./components/thankyou";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/' element={<About />} />
        <Route path='/amount' element={<Amount />} />
        <Route path='/thankyou' element={<ThankYou />} />
      </Routes>
    </Router>
  );
}

export default App;
